import useGetUserInfo from "features/users/hooks/useGetUserInfo";
import { RoleRouteProps } from "./RoleRoute.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";
import useUserState from "ui/adapter/state/useUserState";
import { UserRoutes } from "ui/user/router/UserRouter";

const RoleRoute = ({ roles: rolesProp, children }: RoleRouteProps): JSX.Element => {
    const { data: { roles = [] } = {}, isLoading } = useGetUserInfo();
    const { selectedRole } = useUserState();

    if (isLoading) return <></>; // skipcq: JS-0424
    return (
        <ProtectedRoute isAllowed={roles.some((role) => rolesProp.includes(role.roleType))} redirectPath={UserRoutes.SELECT_ROLE}>
            <ProtectedRoute isAllowed={Boolean(selectedRole)} redirectPath={UserRoutes.SELECT_ROLE}>
                {children}
            </ProtectedRoute>
        </ProtectedRoute>
    );
};

export default RoleRoute;